import { Component, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import pdfMake, { TCreatedPdf } from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { fillColor, hLineColor, vLineColor, quitVLineColor } from './helpers';
import { gests, legalAsistance, mantenance, secure, textNotes } from './txts';

import moment from 'moment';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DEFAULT_NAME_QUOTER } from 'src/app/pages/buro/pages/identidad/constants';
import { PeriodType, PeriodTypeName } from 'src/app/utils/utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-pdf-ford',
  templateUrl: `./pdf-ford.component.html`,
  styleUrls: ['./pdf-ford.component.scss'],
})
export class PdfFordComponent implements OnDestroy, OnChanges {
  @Input() dataQuoter!: any;
  @Input() deadlineSelect!: any;
  @Input() stateSelected!: any;
  @Input() registrationState!: any;
  @Input() insuranceSelected!: any;
  @Input() car!: any;
  @Input() show: boolean = true;
  @Input() donwloadAtumatic: boolean = false;
  @Input() name: string = DEFAULT_NAME_QUOTER;
  @Input() allDeadlineSelect!: any;
  @Input() ruleFifteen!: boolean;

  urlEncode64 = require('../../../mocks/logo.json');

  quoterDate: any = '';
  carObject: any;

  carIdCost: any = 'N/A';
  carLicenseCost: any = 'N/A';
  carManagmentCost: any = 'N/A';
  carVerificationCost: any = 'N/A';
  flete: any = 'N/A';
  total: any = 'N/A';

  paperWorkCost: any = 0;

  pdfOpen!: TCreatedPdf;
  protectionPlus: string = 'No';
  substituteCar: string = 'Si';

  agencyExpenses = 0;
  maintenanceExpenses = 0;

  tipColor = `${environment.templateSuffix === '' ? '#fe5000' : '#f15c22'}`;
  tipColorHeader = '#ececec';
  colorGrey = '#ececec';
  border1 = [true, true, false, false];
  border2 = [true, false, false, false];
  border3 = [true, false, false, true];

  formatter = new Intl.NumberFormat('es-MX');

  isAfin: boolean = false;
  isLeasing: boolean = false;
  isRandR: boolean = false;
  productType: string = '';
  allDeadlines: any;
  periodsMonthName = PeriodTypeName;
  periodsMonthAll: string[] = ['period24']
  periodsMonth: any = []
  blueColor = '#fe5000';

  destroy: Subject<boolean> = new Subject<boolean>();

  ngOnChanges(changes: SimpleChanges): void {
    if (this.donwloadAtumatic) {
      this.createPdf();
    }
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.unsubscribe();
  }

  createPdf() {
    this.getDataCotization();
    this.loadPdf();
  }

  getDataCotization() {
    this.initParameters();
  }

  initParameters() {
    this.quoterDate = moment().format('DD/MM/YYYY');
    this.isAfin = `${this.deadlineSelect.concept}`.toLowerCase() === 'afin';
    this.isRandR = `${this.deadlineSelect.concept}`.toLowerCase() === 'rr';
    this.productType = `${this.deadlineSelect.concept}`.toLowerCase() === 'afin' || `${this.deadlineSelect.concept}`.toLowerCase() === 'rr' ? 'Rent2Buy' : this.deadlineSelect.concept;

    if (this.isAfin || this.isRandR) {
      this.carIdCost = this.formatText(
        this.deadlineSelect.deliveryCost.carIdCost
      );
      this.carLicenseCost = this.formatText(
        this.deadlineSelect.deliveryCost.carLicenseCost
      );
      this.carManagmentCost = this.formatText(
        this.deadlineSelect.deliveryCost.carManagmentCost
      );
      this.carVerificationCost = this.formatText(
        this.deadlineSelect.deliveryCost.carVerificationCost
      );
      this.flete = this.formatText(this.deadlineSelect.deliveryCost.flete);
      this.total = this.formatText(this.deadlineSelect.deliveryCost.total);

      this.agencyExpenses = 0;

      this.maintenanceExpenses = this.dataQuoter.includeMaintenance
        ? this.deadlineSelect.deliveryCost.maintenanceExpenses
        : 0;

      this.paperWorkCost =
        this.deadlineSelect.initialPaymentDetail.paperWorkCost;
    }

    this.protectionPlus = this.dataQuoter.protectionPlus ? 'Si' : 'No';
    this.substituteCar = this.dataQuoter.substituteCar ? 'Si' : 'No';

    const prodTemp: any = this.allDeadlineSelect[this.deadlineSelect.concept.toLowerCase()];
    this.periodsMonth = [];
    this.periodsMonthAll.forEach((period: any) => {
      if (prodTemp[period] !== undefined) {
        this.periodsMonth.push(period)
      }
    });
  }

  loadPdf() {
    let periodSelected = `period${this.deadlineSelect.period}`;

    let contentDefinition;


    contentDefinition = [

      {
        columns: [

          {
            style: ['tableTitle', 'alingCenter'],
            table: {
              widths: [118],
              body: ['']
            },
            layout: 'noBorders',
          }
        ],
      },
      {
        style: ['tableTitle', 'alingCenter'],
        table: {
          widths: [505],
          body: [
            [this.getCellCss('PAGO MENSUAL', '#fff', this.tipColor, true)],
          ],
        },
        layout: 'noBorders',
      },
      {
        columns: [
          this.getPaymentTitle(),
          this.getBodyPayment(this.periodsMonth[this.periodsMonth?.indexOf(periodSelected)]),
        ],
      },
      {
        style: ['tableTitle', 'alingCenter'],
        table: {
          widths: [505],
          body: [
            [this.getCellCss('PAGO INICIAL', '#fff', this.tipColor, true)],
          ],
        },
        layout: 'noBorders',
      },
      {
        columns: [
          this.getInitialPaymentTitle(),

          this.getInitialPaymentBody(this.periodsMonth[this.periodsMonth?.indexOf(periodSelected)]),
        ],
      },
      {
        style: ['tableTitle', 'alingCenter'],
        table: {
          widths: [505],
          body: [
            [this.productType === 'Rent2Buy' ? this.getCellCss(`VALOR DE COMPRA`, '#fff', this.tipColor, true) : null],
          ],
        },
        layout: 'noBorders',
      },
      {
        columns: [
          this.productType === 'Rent2Buy' ? this.getPurchaseValueTitle() : null,
          this.productType === 'Rent2Buy' ? this.getPurchaseValues(this.periodsMonth[this.periodsMonth?.indexOf(periodSelected)]) : null,
        ],
      }
    ]



    const pdfDefinition: any = {
      pageMargins: [40, 80, 40, 60],
      header: this.getHeader(),
      content: [
        {
          columns: this.getHeadersAfinRR(),
        },
        contentDefinition,
        {
          width: 'auto',
          style: 'tableExample',
          table: {
            body: this.getBodyDetails(),
          },
          layout: 'lightHorizontalLines',
        },
        {
          width: 'auto',
          style: 'tableExample',
          table: {
            body: this.getBodyNotesRR(),
          },
          layout: 'lightHorizontalLines',
        },
      ],
      styles: {
        header: {
          fontSize: 10,
          bold: true,
          alignment: 'justify',
        },
        tableFirst: {
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
        tableExample: {
          width: 500,
          fontSize: 8,
          margin: [0, 5, 0, 10],
        },
        tableTitle: {
          fontSize: 10,
          margin: [1, 10, 0, 0],
          bold: true,
        },
        alingCenter: {
          alignment: 'center',
        },
        tableBody: {
          fontSize: 8,
          margin: [0, 0, 0, 10],
        },
        tableHeader: {
          bold: true,
          fontSize: 9,
          color: 'black',
        },
        negritas: {
          blod: true,
        },
        headerTable: {
          bold: true,
          background: this.tipColor,
          alignment: 'center',
        },
        backColor: this.getBackColor(),
      },
      info: {
        title: this.name
      }
    };
    this.pdfOpen = pdfMake.createPdf(pdfDefinition);
    this.openPdf();
  }

  openPdf() {
    this.pdfOpen.open();
  }

  getCellCss(text: string, color: string, fillColorCol: string, bold: boolean) {
    return {
      text,
      color,
      fillColor: fillColorCol,
      bold,
    };
  }

  getCellCssHeader(
    text: string,
    color: string,
    border: boolean[],
    fillColorCol: string,
    bold: boolean
  ) {
    return {
      border,
      text,
      color,
      fillColor: fillColorCol,
      bold,
    };
  }

  getLayout() {
    return { hLineColor, vLineColor };
  }

  getLayoutQuitLines() {
    return { vLineColor: quitVLineColor, hLineColor: '#ececec' };
  }

  getBackColor() {
    return { fillColor };
  }

  getRate() {
    let rate = 0;
    const period = this.deadlineSelect.period;
    rate = this.deadlineSelect[`tasaFinalCxA${period}`];
    return `${rate * 100}%`;
  }

  formatText(element: any) {
    return `$${this.formatter.format(element)}`;
  }
  formatTextRound(element: any) {
    return `$${this.formatter.format(element.toFixed(2))}`;
  }

  getHeader() {
    return [
      {
        table: {
          widths: '*',
          body: [
            [
              {
                border: [false, false, false, false],
                fillColor: this.tipColor,
                image: `data:image/png;base64,${this.urlEncode64.logoUrlBase64}`,
                width: 110,
                height: 40,
                margin: [25, 10, 0, 10],
              },
            ],
          ],
        },
      },
    ];
  }

  /**
   * Primer Tabla Infomación General
   * Fecha | Vehiculo | Precio | Kilometraje | Uso Permitido | Plazo
   * @return {*} 
   * @memberof PdfFordComponent
   */
  getHeadersAfinRR() {
    return [
      {
        width: '*',
        style: 'tableFirst',
        table: {
          widths: [90, 130],
          body: [
            [
              this.getCellCssHeader(
                'Fecha',
                '#000',
                this.border1,
                this.colorGrey,
                true
              ),
              `${this.quoterDate}`,
            ],
            [
              this.getCellCssHeader(
                'Vehículo',
                '#000',
                this.border2,
                this.colorGrey,
                true
              ),
              this.getHeaderVehiculo(),
            ],
            [
              this.getCellCssHeader(
                'Precio del Auto con IVA',
                '#000',
                this.border2,
                this.colorGrey,
                true
              ),
              `$${this.formatter.format(this.car.priceWithIva)}`,
            ],
            [
              this.getCellCssHeader(
                'Kilometraje max. anual',
                '#000',
                this.border2,
                this.colorGrey,
                true
              ),
              `${this.formatter.format(this.dataQuoter.km)}`,
            ],
            [
              this.getCellCssHeader(
                'Uso Permitido',
                '#000',
                this.border2,
                this.colorGrey,
                true
              ),
              `Particular`,
            ],
            [
              this.getCellCssHeader(
                'Plazo Elegido',
                '#000',
                this.border3,
                this.colorGrey,
                true
              ),
              `${this.deadlineSelect.period} Meses`,
            ]
          ]
        },
        layout: this.getLayout(),
      },
      {
        width: '*',
        style: 'tableFirst',
        table: {
          widths: [90, 130],
          margin: [0, 5, 15, 10],
          body: [
            [
              this.getCellCssHeader(
                'Emplacamiento en',
                '#000',
                this.border1,
                this.colorGrey,
                false
              ),
              `${this.isEmpty(this.registrationState) ? this.stateSelected.stateName : this.registrationState}`,
            ],
            [
              this.getCellCssHeader(
                'Entidad de Seguro',
                '#000',
                this.border2,
                this.colorGrey,
                false
              ),
              `${this.stateSelected.stateName}`,
            ],
            [
              this.getCellCssHeader(
                'Aseguradora de Auto',
                '#000',
                this.border2,
                this.colorGrey,
                false
              ),
              `${this.insuranceSelected?.insurance?.key ?? 'Por confirmar'}`,
            ],
            [
              this.getCellCssHeader(
                'Producto',
                '#000',
                this.border3,
                this.colorGrey,
                false
              ),
              `${this.productType}`,
            ],
            [
              this.getCellCssHeader(
                'Monto Total del Seguro sin IVA',
                '#000',
                this.border3,
                this.colorGrey,
                false
              ),
              `$${this.formatter.format(this.deadlineSelect.insuranceCarTotal)}`
            ],
          ],
        },
        layout: this.getLayout(),
      },
    ];
  }
  /**
   * Función que retorna el nombre del vehículo ya formateado
   * Marca | Submarca | Versión
   * @memberof PdfFordComponent
   */
  getHeaderVehiculo() {
    let brand = this.car.brand ? `${this.car.brand}` : '';
    let subBrand = this.car.subBrand ? `${this.car.subBrand}` : '';
    let version = this.car.version ?? '';

    return `${brand} ${subBrand} ${version}`;
  }

  /**
   * Primer Tabla de Pagos - Detalle
   * PAGO MENSUAL 
   * Renta Base | Asistencia Legal | Admon. de Mantenimiento | Seguro Automotriz | Total con IVA
   * @return {*} 
   * @memberof PdfFordComponent
   */
  getPaymentTitle() {
    let paymentRows: any = [
      [
        this.getCellCss('Concepto', '#000', this.colorGrey, true),
      ],
      ['Renta Base',],
      ['Asistencia Legal'],
      ['Admon. de Mantenimiento'],
    ];
    if (!this.ruleFifteen) {
      paymentRows.push(['Seguro Automotriz']);
    }

    paymentRows.push([
      {
        text: 'Total con IVA',
        style: 'tableHeader',
      }
    ]);

    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: paymentRows,
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  getInitialPaymentTitle() {
    let data: any = [
      [this.getCellCss('Concepto', '#000', this.colorGrey, true)],
      ['Renta anticipada'],
    ]

    if (this.ruleFifteen) {
      data.push([
        'Seguro de contado'
      ]);
    }

    let total = [
      {
        text: 'Total',
        style: 'tableHeader',
      },
    ]

    data.push(total)


    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: data,
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  getDeliveryProceduresTitle() {
    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: [
              [
                this.getCellCss('Concepto', '#000', this.colorGrey, true),
              ],
              ['Alta de Placas'],
              ['Tenencias / Derechos'],
              ['Gestorías'],
              ['Verificación'],
              [
                { text: 'Total', style: 'tableHeader' },
              ],
            ],
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  /**
   * 
   * @return {*} 
   * @memberof PdfComponent
   * @author victor.mendez
   */
  getPurchaseValueTitle() {
    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: [
              [
                this.getCellCss('Concepto', '#000', this.colorGrey, true),
              ],
              ['Valor de compra con IVA'],

            ],
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  /**
   * Función que retorna el cuerpo de la tabla de detalles, con los valores del valor de compra
   * @param {string} numPeriod
   * @return {*} 
   * @memberof PdfComponent
   * @author victor.mendez
   */
  getPurchaseValues(numPeriod: string) {
    const period = numPeriod as PeriodType
    const deadlineSelected = this.allDeadlineSelect[this.deadlineSelect.concept.toLowerCase()][period];

    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: [
              [
                this.getCellCss('Valores', '#000', this.colorGrey, true),
              ],
              [this.formatText(deadlineSelected.purchaseValue.toFixed(2))],
            ],
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  getBodyPayment(numPeriod: string) {
    const period = numPeriod as PeriodType;
    const deadlineSelected = this.allDeadlineSelect[this.deadlineSelect.concept.toLowerCase()][period];

    let insuranceCarRow = [
      this.formatText(this.ruleFifteen ? 0 : deadlineSelected.monthlyPaymentDetail.insuranceCar), // Seguro Automotriz
    ];

    let bodyRows: any = [
      [
        this.getCellCss('Valores', '#000', this.colorGrey, true),
      ],
      [
        this.formatText(
          deadlineSelected.monthlyPaymentDetail.monthlyRate ?? ''
        ),
      ],
      [`Incluido en renta`], // Asistencia legal 150
      [`Incluido en renta`], // admon de mantenimiento 129
    ];

    if (!this.ruleFifteen) {
      bodyRows.push(insuranceCarRow);
    }

    bodyRows.push([
      {
        text: this.formatTextRound(this.ruleFifteen ? (deadlineSelected.monthlyPaymentDetail.monthlyRate + deadlineSelected.monthlyPaymentDetail.maintenance + 150) * 1.16 : deadlineSelected.monthlyPaymentDetail.total),
        style: 'tableHeader',
      },
    ]);

    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: bodyRows,
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  getInitialPaymentBody(numPeriod: string) {
    const period = numPeriod as PeriodType
    const deadlineSelected = this.allDeadlineSelect[this.deadlineSelect.concept.toLowerCase()][period]


    let data: any = [
      [this.getCellCss('Valores', '#000', this.colorGrey, true)],
      [this.formatTextRound(this.ruleFifteen ? (deadlineSelected.initialPayment - (deadlineSelected.insuranceCarTotal * 1.16)) : deadlineSelected.initialPayment || 0)] // Enganche
    ]

    let total = [
      {
        text: this.formatTextRound(deadlineSelected.initialPayment || 0), // Total pago inicial
        style: 'tableHeader',
      },
    ]

    if (this.ruleFifteen)
      data.push(
        [
          this.formatTextRound(deadlineSelected.insuranceCarTotal * 1.16) // Seguro de contado
        ],
        total
      );
    else
      data.push(total)


    return [
      [
        {
          style: 'tableBody',
          table: {
            widths: [110],
            body: data,
          },
          layout: this.getLayoutQuitLines(),
        },
      ],
    ];
  }

  private deliveryCost(field: string, deadlineSelected: any) {
    if (this.isLeasing || this.isAfin || this.isRandR) {
      return this.formatText(deadlineSelected.deliveryCost[field]);
    } else {
      return 'N/A'
    }
  }


  getBodyPagoInicial() {
    let data: any = [
      [
        this.getCellCss('Concepto', '#000', this.colorGrey, true),
        this.getCellCss('Valores', '#000', this.colorGrey, true),
      ],
      [
        'Rentas Adelantadas',
        this.formatText(this.deadlineSelect.initialPaymentDetail.advancedRent),
      ]
    ];

    if (
      this.deadlineSelect.trasladoCost !== 0 &&
      this.deadlineSelect.trasladoCost !== undefined
    ) {
      data.push([
        'Costo de traslado',
        this.formatText(this.deadlineSelect.trasladoCost),
      ]);
    }

    let total = [
      {
        text: 'Total',
        style: 'tableHeader',
      },
      {
        text: this.formatText(
          this.deadlineSelect.initialPaymentDetail.total +
          (this.deadlineSelect?.trasladoCost || 0)
        ),
        style: 'tableHeader',
      },
    ];

    if (this.isAfin)
      data.push(
        [
          'Ratificación de Contrato',
          this.formatText(
            this.deadlineSelect.initialPaymentDetail.contractRatification
          ),
        ],
        total
      );
    else data.push(total);

    return data;
  }

  getBodyMonths() {
    const period = this.deadlineSelect.period;
    const monthlyTotal = this.formatText(
      this.deadlineSelect.monthlyPaymentDetail.total
    );
    const arr = [];

    for (let i = 0; i < period; i++) {
      arr.push([`${i + 1}`, monthlyTotal]);
    }

    return arr;
  }

  getBodyDetails() {
    return [
      [{ text: 'DETALLE DE SERVICIOS', alignment: 'center' }],
      [
        {
          text: [
            this.getCellCss('\n Asistencia legal: ', '#000', '#fff', true),
            legalAsistance,

            this.getCellCss(
              'Administración de Mantenimiento: ',
              '#000',
              '#fff',
              true
            ),
            mantenance,

            this.getCellCss('Seguro Automotriz: ', '#000', '#fff', true),
            secure,

            this.getCellCss('Gestoría Inicial: ', '#000', '#fff', true),
            gests,
          ],
          alignment: 'justify',
        },
      ],
    ];
  }

  getBodyNotesRR() {
    return [
      [{ text: 'NOTAS', alignment: 'center' }],
      [
        {
          text: `${textNotes}`,
          alignment: 'justify',
        }
      ]
    ];
  }

  getPdfBase64(): Promise<string> {
    return new Promise((resolve) => {
      this.pdfOpen.getBase64((base64) => resolve(base64));
    });
  }

  getPeriodName(numPeriod: string) {
    const period = numPeriod as PeriodType
    return this.periodsMonthName[period];
  }


  isEmpty(value: string) {
    return value === '' || value === undefined || value === null;
  }
}
